// ─── Cuándo se bloquea una navegación por cambios sin guardar ───────────────
//
// Se bloquea solo si hay cambios Y se va a OTRA pantalla: otra ruta, o la misma
// con otra búsqueda (las pestañas de Curso viven en `?tab=`, y cambiar de
// pestaña desmonta el libro de notas igual que irse). Un cambio de `#hash` en
// la misma pantalla no desmonta nada y no se interrumpe.

interface Loc {
  pathname: string;
  search: string;
}

export function blocksNavigation(when: boolean, current: Loc, next: Loc): boolean {
  return when && (current.pathname !== next.pathname || current.search !== next.search);
}
